<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13pcHHw/tc-custom/9781635761634.jpg?1701061762975" alt="This image is the cover for the book I Cannot Get You Close Enough"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Cannot Get You Close Enough
      </h1>
      <p class="bookDescription body article font2">
        <b>Three intertwining novellas about love, death, and the bonds of blood: </b><b>“To say that Ellen Gilchrist can write is to say that Placido Domingo can sing</b><b>.”—Jonathan Yardley, <i>The Washington Post</i></b><br/><br/> Journeying through the lives of different members of the Hand family, Ellen Gilchrist weaves together tumultuous relationships that are bound by blood. A harrowing custody battle leads Anna Hand to Istanbul and back to ensure once and for all that her niece is safe from her conniving mother’s ploys. Jessie, finally free from her mother’s influence, has her life upended when Olivia, the sister she never knew she had, appears at the Hands’ home. Between this and the shocking loss of her aunt, Jessie doesn’t know if her resentment of Olivia comes from their chaotic meeting or something suspicious bubbling just beneath Olivia’s surface.<br/><br/> Meanwhile Olivia, the half-Native American child who had never known a normal family, must cope with this new world of high society. Losing Anna, and having a dark and desperate secret exposed, may send her back to Tahlequah—if it doesn’t send her over the edge first.<br/><br/> And Anna, leaving a legacy of literature in her wake, may do more harm in death than she ever wanted in life, as her sister enters a vicious fight to recover her lost writing…<br/>  <br/> “Always she takes the long, comic view of her characters' frailties, for only through the chaos they create, she seems to suggest, do family trees writhe toward the light.”—<i>The New York Times</i><br/>  <br/> “Gilchrist brilliantly captures the intimate accents and rhythms of a family under stress.”—<i>Publishers Weekly</i><br/>  <br/> “A thoroughly engaging work.”—<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Gilchrist
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?811f402e